import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import { AccordionSection } from "./AccordionSection";
import { SectionErrors } from "./SectionErrors";
import { SignedImage } from "../../common/SignedImage";

export function BenchmarkSection({ jobToComplete, benchmarkSubmitHandler, uploadBenchmarkToClientFunc, errorMessage }) {
  const isComplete = jobToComplete.completionDetail.benchmarkComplete;
  const cameraInputRef = useRef(null);
  const uploadInputRef = useRef(null);
  const [selectedFileName, setSelectedFileName] = useState(null);

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedFileName(e.target.files[0].name);
    }
    uploadBenchmarkToClientFunc(e);
  };

  return (
    <AccordionSection
      id="benchmark"
      headerId="headerBenchmark"
      collapseId="collapseBenchmark"
      number={3}
      title="Completed Benchmark"
      isComplete={isComplete}
    >
      {isComplete ? (
        jobToComplete.completionDetail.completedBenchmarkImage?.url ? (
          <SignedImage
            className="mb-2"
            src={jobToComplete.completionDetail.completedBenchmarkImage.url}
            style={{ height: 300 }}
          />
        ) : null
      ) : (
        <form onSubmit={benchmarkSubmitHandler}>
          <p className="text-muted mb-2">Provide an image of the completed benchmark document</p>
          <div className="d-flex flex-column flex-md-row gap-2 mb-3">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => cameraInputRef.current.click()}
            >
              Take Photo
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => uploadInputRef.current.click()}
            >
              Upload File
            </button>
          </div>
          {selectedFileName && (
            <p className="text-muted mb-3">
              <small>Selected: {selectedFileName}</small>
            </p>
          )}
          <input
            ref={cameraInputRef}
            type="file"
            name="benchmarkImage"
            accept="image/*"
            capture="environment"
            onChange={handleFileChange}
            className="d-none"
          />
          <input
            ref={uploadInputRef}
            type="file"
            name="benchmarkImage"
            accept="image/*, .pdf"
            onChange={handleFileChange}
            className="d-none"
          />
          <div className="d-flex flex-column flex-md-row justify-content-md-end gap-2 mt-2">
            <button onClick={benchmarkSubmitHandler} type="submit" className="btn btn-primary" disabled={isComplete}>
              Submit Benchmark
            </button>
          </div>
          <SectionErrors errorMessage={errorMessage} section="benchmark" />
        </form>
      )}
    </AccordionSection>
  );
}

BenchmarkSection.propTypes = {
  jobToComplete: PropTypes.object.isRequired,
  benchmarkSubmitHandler: PropTypes.func.isRequired,
  uploadBenchmarkToClientFunc: PropTypes.func.isRequired,
  errorMessage: PropTypes.array.isRequired,
};
